module.exports = __webpack_public_path__ + "img/logo.dcec8d22.png";